import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private readonly SPACES_PAGE = '/spaces';
  private readonly SEARCH_HOME_PAGE = '/search';
  private readonly SEARCH_RESULTS_PAGE = '/search/results';
  private readonly CONNECTORS_PAGE = '/my-apps';
  private readonly PROFILE_PAGE = '/my-account';
  private readonly WORKSPACE_BILLING_PAGE = '/workspace/billing';
  private readonly WORKSPACE_PRICING_PLANS_PAGE = '/workspace/pricing-plans';
  private readonly WORKSPACE_MEMBERS = '/workspace/members';
  private readonly WORKSPACE_PAGE = '/workspace';
  private readonly AGENTS_PAGE = '/agents';
  private readonly LOGIN_PAGE = '/auth/login';
  private readonly ONBOARDING_STEP_ONE = '/onboarding/step-one';
  private readonly ONBOARDING_STEP_TWO = '/onboarding/step-two';
  private readonly ONBOARDING_STEP_THREE = '/onboarding/step-three';
  private readonly ONBOARDING_STEP_FOUR = '/onboarding/step-four';
  private readonly ONBOARDING_STEP_FIVE = '/onboarding/step-five';
  private readonly ERRORS_NOT_FOUND = '/errors/not-found';
  private readonly ERRORS_TIMEOUT = '/errors/timeout-error';
  private readonly ERRORS_FORBIDDEN = '/errors/forbidden';
  private readonly ERRORS_INTERNAL_SERVER_ERROR = '/errors/internal-server-error';
  private readonly ERRORS_BAD_REQUEST = '/errors/bad-request';

  public getSpacesPageURL = (): string => this.SPACES_PAGE;
  public getSpacesDetailsPageURL = (id: string): string => `${this.SPACES_PAGE}/${id}`;
  public getSearchHomePageURL = (): string => this.SEARCH_HOME_PAGE;
  public getSearchResultsPageURL = (id: string): string => `${this.SEARCH_RESULTS_PAGE}/${id}`;
  public getSearchResultsPagePlainURL = (): string => this.SEARCH_RESULTS_PAGE;
  public getConnectorsPageURL = (): string => this.CONNECTORS_PAGE;
  public getProfilePageURL = (): string => this.PROFILE_PAGE;
  public getBillingPageURL = (): string => this.WORKSPACE_BILLING_PAGE;
  public getPricingPlansPageURL = (): string => this.WORKSPACE_PRICING_PLANS_PAGE;
  public getManageUsersPageURL = (id: string): string => `${this.WORKSPACE_MEMBERS}/${id}`;
  public getLoginPageURL = (): string => this.LOGIN_PAGE;
  public getOnboardingStepOnePageURL = (): string => this.ONBOARDING_STEP_ONE;
  public getOnboardingStepTwoPageURL = (): string => this.ONBOARDING_STEP_TWO;
  public getOnboardingStepThreePageURL = (): string => this.ONBOARDING_STEP_THREE;
  public getOnboardingStepFourPageURL = (): string => this.ONBOARDING_STEP_FOUR;
  public getOnboardingStepFivePageURL = (): string => this.ONBOARDING_STEP_FIVE;
  public getNotFoundPageURL = (): string => this.ERRORS_NOT_FOUND;
  public getTimeoutPageURL = (): string => this.ERRORS_TIMEOUT;
  public getForbiddenPageURL = (): string => this.ERRORS_FORBIDDEN;
  public getInternalServerErrorPageURL = (): string => this.ERRORS_INTERNAL_SERVER_ERROR;
  public getBadRequestPageURL = (): string => this.ERRORS_BAD_REQUEST;
  public getWorkspacePageURL = (): string => this.WORKSPACE_PAGE;
  public getAgentsPageURL = (): string => this.AGENTS_PAGE;
}
